import React from "react";
import { HiBriefcase, HiCalendar, HiLocationMarker } from "react-icons/hi";

const Experience = () => {
  const experiences = [
    {
      title: "Senior Full-Stack Developer",
      company: "E-LMIS (Ethiopian Labour Market Information System)",
      location: "Addis Ababa, Ethiopia",
      period: "Jan 2025 – Present",
      type: "Full-time",
      description: "Leading front-end architecture and API integrations for national labour data systems.",
      highlights: [
        "Lead frontend and backend development using React, Hasura GraphQL, NestJS, and PostgreSQL",
        "Architect and maintain GraphQL & REST APIs with complex data models",
        "Built data-intensive dashboards and reusable UI components aligned with design systems",
        "Optimize performance through lazy loading, code splitting, and load time improvements",
        "Document architecture and API contracts to streamline team onboarding"
      ],
      technologies: ["React", "Hasura GraphQL", "NestJS", "PostgreSQL", "TypeScript", "CI/CD"]
    },
    {
      title: "Junior Full-Stack Developer",
      company: "InspireTech Engineering",
      location: "Addis Ababa, Ethiopia",
      period: "Jan 2025 – Mar 2025",
      type: "Full-time",
      description: "Built company website and admin platform with modern React stack.",
      highlights: [
        "Built and deployed official company website and admin portal",
        "Implemented responsive layouts and accessibility best practices",
        "Created admin features for content management, job portal, and user contact management",
        "Authored technical documentation and coding standards for team consistency"
      ],
      technologies: ["React", "TailwindCSS", "AWS Amplify"]
    },
    {
      title: "Web Developer & Branding Consultant",
      company: "ROBIBON Construction",
      location: "Addis Ababa, Ethiopia",
      period: "Aug 2022 – 2024",
      type: "Part-time",
      description: "Delivered complete web presence and brand identity for construction company.",
      highlights: [
        "Designed and deployed custom responsive corporate website",
        "Delivered brand identity materials (logos, brochures, site assets)",
        "Managed hosting, maintenance, and SEO optimization",
        "Advised on technical strategy for digital presence"
      ],
      technologies: ["HTML", "CSS/SCSS", "JavaScript", "SEO"]
    },
    {
      title: "IT Intern (Networking & Hardware)",
      company: "Commercial Bank of Ethiopia, Yeka District",
      location: "Addis Ababa, Ethiopia",
      period: "Aug 2023 – Nov 2023",
      type: "Internship",
      description: "Enhanced enterprise network infrastructure and ATM monitoring systems.",
      highlights: [
        "Assisted Information Systems team in enterprise networking and hardware support",
        "Supported ATM monitoring and banking application systems",
        "Produced network diagrams and configuration plans using Cisco Packet Tracer"
      ],
      technologies: ["Networking", "Cisco", "Hardware Support"]
    }
  ];

  return (
    <div
      name="experience"
      className="w-full min-h-screen bg-[#0a192f] text-gray-300 py-20"
    >
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="pb-12">
          <h2 className="text-4xl sm:text-5xl font-bold inline-block border-b-4 border-cyan-600">
            Experience
          </h2>
          <p className="text-[#8892b0] text-lg mt-4">
            My professional journey and accomplishments
          </p>
        </div>

        <div className="space-y-8">
          {experiences.map((exp, index) => (
            <div
              key={index}
              className="bg-[#112240] rounded-lg p-6 sm:p-8 border border-cyan-600 border-opacity-10 hover:border-opacity-30 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-600/10"
            >
              <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-4 mb-4">
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-white mb-2">
                    {exp.title}
                  </h3>
                  <div className="flex items-center gap-2 text-cyan-500 font-semibold text-lg mb-3">
                    <HiBriefcase className="text-xl" />
                    <span>{exp.company}</span>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row lg:flex-col gap-3 text-sm text-[#8892b0]">
                  <div className="flex items-center gap-2">
                    <HiCalendar className="text-cyan-500" />
                    <span>{exp.period}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <HiLocationMarker className="text-cyan-500" />
                    <span>{exp.location}</span>
                  </div>
                </div>
              </div>

              <p className="text-[#8892b0] text-lg mb-4 italic">
                {exp.description}
              </p>

              <div className="space-y-2 mb-6">
                {exp.highlights.map((highlight, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <span className="text-cyan-500 mt-1 text-lg">▹</span>
                    <p className="text-[#8892b0]">{highlight}</p>
                  </div>
                ))}
              </div>

              <div className="flex flex-wrap gap-2">
                {exp.technologies.map((tech, idx) => (
                  <span
                    key={idx}
                    className="px-3 py-1 bg-cyan-600 bg-opacity-10 text-cyan-400 rounded-md text-sm border border-cyan-600 border-opacity-20"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
